export default "__VITE_ASSET__HFWhijQZ__"